ui-cms-contact-channels-footer {
  display: block;

  .ui-cms-contact-channels-footer-container {
    display: flex;
    flex-direction: column;
    gap: $sd-spacing-6;

    .contactbox {
      &__item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        line-height: 1.5;
      }

      &__icon {
        margin-right: $sd-spacing-5;
        min-width: $sd-spacing-12;
        min-height: $sd-spacing-12;
        width: $sd-spacing-8;
        height: $sd-spacing-8;
      }
    }
  }
}

.contactbox__icon {
  width: $sd-spacing-8;
  height: $sd-spacing-8;
}

.nowrap {
  white-space: nowrap;
}
